(function(window, $, undefined){
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Security = window.JVZoo.Security || {};

    /**
     * @type string
     */
    var _csrfHash = undefined;

    /**
     * This value must be synchronized with the configuration file value 'csrf_token_name'
     * @type {string}
     * @private
     */
    const _csrfFieldName = 'csrf_protected';

    /**
     * @return {string}
     */
    window.JVZoo.Security.GetCsrfFieldName = function () {
        return _csrfFieldName;
    };

    /**
     * This value must be synchronized with the configuration file value 'csrf_cookie_name'
     * @type {string}
     * @private
     */
    const _csrfCookieName = 'csrf_protected';

    /**
     * @return {string}
     */
    window.JVZoo.Security.GetCsrfCookieName = function () {
        return _csrfCookieName;
    };

    /**
     * This value must be synchronized with the configuration file value 'csrf_expire'
     * @type {number}
     * @private
     */
    const _csrfExpiration = 7200;

    /**
     * @return {string}
     */
    window.JVZoo.Security.GetCsrfExpirationSeconds = function () {
        return _csrfExpiration;
    };

    /**
     * Sets the csrf value for use with JS HTTP requests
     * @param csrfHash string
     * @constructor
     */
    window.JVZoo.Security.SetCsrfHash = function (csrfHash) {
        _csrfHash = csrfHash;
    };

    /**
     * Gets the csrf value for use with JS HTTP requests
     * @return string
     */
    window.JVZoo.Security.GetCsrfHash = function () {
        // TODO: Try to read csrf value from cookie, and if needed fallback to the _csrfHash value
        if (_csrfHash) {
            return _csrfHash;
        }
        return 'NO_CSRF';
    };
})(window, jQuery);